import { UserProgram } from 'models/programs.types';

import { DEEP_LINK_PREFIXES, PROGRAM_CONFIGS } from './constants';

export const getProgramBy = <K extends keyof (typeof PROGRAM_CONFIGS)[number]>(
  field: K,
  key?: (typeof PROGRAM_CONFIGS)[number][K] | null
): (typeof PROGRAM_CONFIGS)[number] | undefined => {
  if (!key) return undefined;
  return PROGRAM_CONFIGS.find((p) => p[field] === key);
};

/**
 * Whether the patient has a weight-management program at all — Active or Inactive.
 *
 * The single definition behind `useMyPrograms().hadOrHasWeightManagement`, so a caller holding a
 * `/my-programs` response rather than the store still asks the route guards' question. The
 * redirect into `/migrate-to-wm` and that route's own guard answering this differently is what
 * bounced freemium patients between the flow and a 404.
 */
export const hasWeightManagementProgram = (programs: UserProgram[]) =>
  programs.some((p) => p.program.category === 'weight-management');

export const checkWMNotCompletedOnboarding = (
  completedInitialAppointment: boolean,
  weightManagement?: UserProgram
) => weightManagement && !completedInitialAppointment;

export const getDeepLinkPrefix = () => {
  const env = import.meta.env.VITE_ENV || 'development';
  return DEEP_LINK_PREFIXES[env as keyof typeof DEEP_LINK_PREFIXES] || '';
};
